import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Rules from "@/pages/Rules";
import OrderStatus from "@/pages/OrderStatus";
import OrderLanding from "@/pages/OrderLanding";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";

function useForceLightTheme() {
    useEffect(() => {
        // Belt-and-braces: force the light theme at runtime too, so no
        // system/browser dark preference can ever repaint the app.
        const set = () => {
            document.documentElement.style.setProperty(
                "color-scheme",
                "light",
                "important",
            );
            document.documentElement.style.setProperty(
                "background-color",
                "#ffffff",
                "important",
            );
            document.body.style.setProperty(
                "background-color",
                "#ffffff",
                "important",
            );
            document.body.style.setProperty("color", "#111111", "important");
            document.documentElement.classList.remove("dark");
            document.documentElement.removeAttribute("data-theme");
            document.body.classList.remove("dark");
            const root = document.getElementById("root");
            if (root) {
                root.style.setProperty(
                    "background-color",
                    "#ffffff",
                    "important",
                );
            }
            let meta = document.querySelector('meta[name="theme-color"]');
            if (!meta) {
                meta = document.createElement("meta");
                meta.setAttribute("name", "theme-color");
                document.head.appendChild(meta);
            }
            meta.setAttribute("content", "#ffffff");
        };
        set();
        // If dark-mode preference toggles at OS level while the tab is open.
        const mq = window.matchMedia("(prefers-color-scheme: dark)");
        mq.addEventListener?.("change", set);
        // Guard against any third-party lib toggling .dark later.
        const obs = new MutationObserver(set);
        obs.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["class", "data-theme", "style"],
        });
        return () => {
            mq.removeEventListener?.("change", set);
            obs.disconnect();
        };
    }, []);
}

function App() {
    useForceLightTheme();
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/rules" element={<Rules />} />
                        <Route path="/order" element={<OrderLanding />} />
                        <Route path="/order/:token" element={<OrderStatus />} />
                        <Route path="/tentang-kami" element={<About />} />
                        <Route path="/kontak" element={<Contact />} />
                        <Route
                            path="/kebijakan-privasi"
                            element={<Privacy />}
                        />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors closeButton theme="light" />
        </div>
    );
}

export default App;
